import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {RegisterUserComponent} from '../../../../layout/header/widgets/register-user/register-user.component';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {UserStoreService} from '../../../../core/services/user-store.service';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-modal-registro',
  templateUrl: './modal-registro.component.html',
  styleUrls: ['./modal-registro.component.scss']
})
export class ModalRegistroComponent implements OnInit {
  public userForm: FormGroup;
  comprobacion: boolean;
  showSpinner: boolean;

  constructor(public dialogRef: MatDialogRef<ModalRegistroComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog, private fb: FormBuilder,
              protected userStoreService: UserStoreService, private toastrService: ToastrService) {
    this.userForm = this.fb.group({
      nombre: ['', [Validators.required, Validators.pattern('^([A-Za-z ÑñáéíóúÁÉÍÓÚ]+)$')]],
      apellidos: ['', [Validators.required, Validators.pattern('^([A-Za-z ÑñáéíóúÁÉÍÓÚ]+)$')]],
      telefono: ['', [Validators.required, Validators.maxLength(10), Validators.pattern('^[0-9]+$')]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      fechaNacimiento: ['', [Validators.required]],
      idEmpresa: [1]
    });
  }

  ngOnInit() {
    // setTimeout(() => {
    //         this.dialogRef.close();
    //     },
    //     5000);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  registerUser() {
    this.showSpinner = true;
    this.userStoreService.registerUser(this.userForm.value).subscribe(() => {
        this.toastrService.success('Registro completado exitosamente');
        this.dialogRef.close();
        this.login();

      }, error => {
        if (error.status === 422) {
          this.toastrService.error('Este correo ya se encuentra registrado');
          this.userForm.controls.email.setValue('');
          this.userForm.controls.password.setValue('');
          this.userForm.controls.repeatPassword.setValue('');
        }
      }
    );
  }

  login() {
    this.userStoreService.login(this.userForm.value).subscribe(() => {
        window.location.reload();
      },
      (error) => {
        if (error.status === 401) {
          this.toastrService.error('Credenciales incorrectas');
          this.userForm.reset();
        }
      }
    );
  }
}
